import React, { useState } from 'react'
import OpenEye from '../../../assets/images/eye-show.png'
import ClosedEye from '../../../assets/images/eye-hide.png'

interface InputProps {
  className: string | undefined
  type: string
  placeholder: string
  [rest: string]: any
};

// TODO(https://dopage.atlassian.net/browse/DMVP-433):
// Support keyboard controls. This should know when it has focus and then allow to focus either the the input
// or the visibility controls, and give focus back to parent when appropriate.
const Input: React.FC<InputProps> = ({ className, type, ...rest }: InputProps) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false)

  const togglePasswordVisibility = (): void => {
    setIsPasswordVisible(!isPasswordVisible)
  }

  return (
    <div className='relative'>
      <input className={`${className ?? ''} font-primary bg-transparent text-dopage-lightGreen outline-0 border-[3px] rounded border-dopage-lightGreen`} type={isPasswordVisible ? 'text' : type} {...rest} />
      {type === 'password' && (
        <button
          id='button-input-toggle-visibility'
          type='button'
          className='w-[45px] absolute right-5 top-1/2 -translate-y-1/2 items-center px-2 cursor-pointer'
          onClick={togglePasswordVisibility}
        >
          <img
            src={isPasswordVisible ? ClosedEye : OpenEye}
            alt='toggle visibility'
          />
        </button>
      )}
    </div>
  )
}

export default Input
